// Language picker — the prototype had two (a full one on the intro overlay and a
// flag-only one in the banner). `variant` picks size; `dark` styles it for the
// immersive over-camera capture UI.

import { LANG_FLAGS, LANG_LABELS, OFFERED_LANGS, useI18n, type Lang } from "../lib/i18n";

export function LanguageSwitcher({
  variant = "full",
  dark = false,
}: {
  variant?: "full" | "compact";
  dark?: boolean;
}): React.ReactElement {
  const { lang, setLang } = useI18n();
  const cls =
    variant === "full"
      ? "rounded-md border border-slate-300 bg-white text-sm py-2 px-2"
      : dark
        ? "rounded-xl border border-white/15 bg-black/55 backdrop-blur text-white text-sm py-2 pl-2 pr-6"
        : "rounded border border-slate-300 bg-white/90 text-sm py-1 pl-1 pr-6";
  return (
    <select
      value={lang}
      onChange={(e) => setLang(e.target.value as Lang)}
      data-testid="language-switcher"
      aria-label="Language"
      className={cls}
    >
      {OFFERED_LANGS.map((l) => (
        <option key={l} value={l} className="text-slate-900">
          {variant === "compact" ? LANG_FLAGS[l] : LANG_LABELS[l]}
        </option>
      ))}
    </select>
  );
}
